/**
 * Audit-reports permission ids used by AOD / reports UI.
 * Kept local to avoid importing generated API permission maps.
 */
export const auditReportsPermissions = {
  Reports_Manage: 'audit-reports:reports:manage',
  AodRules_Manage: 'audit-reports:aod-rules:manage',
  AodRules_View: 'audit-reports:aod-rules:view',
} as const;
